import { ConditionAttributes, ConditionEvaluator } from "@evergis/condition";

export function evaluateCondition(condition: string, attributes: ConditionAttributes): boolean | null {
  try {
    const evaluator = new ConditionEvaluator(attributes);
    const result = evaluator.evaluate(condition);

    if (result instanceof Error) {
      return null;
    }

    return !!result;
  } catch {
    return null;
  }
}
